if (!customElements.get('blog-posts')) {
  class BlogPosts extends HTMLElement {
    constructor() {
      super();
      this.onClickHandler = this.onClick.bind(this);
    }

    connectedCallback() {
      if (this.dataset.blogInit === 'true') return;
      this.dataset.blogInit = 'true';

      this.sectionId = this.dataset.sectionId;
      this.blogUrl = this.dataset.blogUrl;
      if (!this.sectionId || !this.blogUrl) return;

      this.addEventListener('click', this.onClickHandler);
      this.bindTagDropdown();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClickHandler);
    }

    async onClick(event) {
      const tagButton = event.target.closest('[data-blog-filter-button]');
      const pageButton = event.target.closest('[data-blog-pagination-button]');
      const loadMoreButton = event.target.closest('[data-blog-load-more-button]');
      if (!tagButton && !pageButton && !loadMoreButton) return;

      const activeTagButton = this.querySelector('[data-blog-filter-button].tag__button--current');
      const currentTagType = activeTagButton?.dataset?.type || 'all';

      let nextTagType = currentTagType;
      let nextPage = 1;

      if (loadMoreButton) {
        nextPage = Number(loadMoreButton.dataset.page || 1);
        await this.fetchAndAppendArticles({ tagType: nextTagType, page: nextPage });
        return;
      } else if (tagButton) {
        nextTagType = tagButton.dataset.type || 'all';
      } else if (pageButton) {
        if (pageButton.classList.contains('pagination__item--current')) return;
        nextPage = Number(pageButton.dataset.page || 1);
      }

      await this.fetchAndReplaceSection({ tagType: nextTagType, page: nextPage });
    }

    async fetchAndReplaceSection({ tagType, page }) {
      const list = this.querySelector('[data-blog-list]');
      const pagination = this.querySelector('[data-blog-pagination]');
      const loadMore = this.querySelector('[data-blog-load-more-container]');
      if (list) list.classList.add('animation');
      if (pagination) pagination.classList.add('animation');
      if (loadMore) loadMore.classList.add('animation');

      const params = new URLSearchParams();
      params.set('section_id', this.sectionId);
      if (page && page > 1) params.set('page', String(page));

      const taggedPath = tagType && tagType !== 'all' ? `${this.blogUrl}/tagged/${tagType}` : this.blogUrl;
      const url = `${taggedPath}?${params.toString()}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const htmlText = await response.text();
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const nextWrapper = html.querySelector('[data-blog-wrapper]');
        if (!nextWrapper) throw new Error('Updated blog section was not found in response');

        this.replaceWith(nextWrapper);
      } catch (error) {
        console.error('Blog section update error:', error);
        if (list) list.classList.remove('animation');
        if (pagination) pagination.classList.remove('animation');
        if (loadMore) loadMore.classList.remove('animation');
      }
    }

    async fetchAndAppendArticles({ tagType, page }) {
      const list = this.querySelector('[data-blog-list]');
      const articleList = this.querySelector('.blog__article-list');
      const pagination = this.querySelector('[data-blog-pagination]');
      const loadMore = this.querySelector('[data-blog-load-more-container]');
      if (!articleList) return;

      if (list) list.classList.add('animation');
      if (pagination) pagination.classList.add('animation');
      if (loadMore) loadMore.classList.add('animation');

      const params = new URLSearchParams();
      params.set('section_id', this.sectionId);
      if (page && page > 1) params.set('page', String(page));

      const taggedPath = tagType && tagType !== 'all' ? `${this.blogUrl}/tagged/${tagType}` : this.blogUrl;
      const url = `${taggedPath}?${params.toString()}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const htmlText = await response.text();
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const nextWrapper = html.querySelector('[data-blog-wrapper]');
        if (!nextWrapper) throw new Error('Updated blog section was not found in response');

        const nextArticleItems = nextWrapper.querySelectorAll('.blog__article-list [data-article-item]');
        nextArticleItems.forEach((item) => articleList.appendChild(item));

        const currentPagination = this.querySelector('[data-blog-pagination]');
        const nextPagination = nextWrapper.querySelector('[data-blog-pagination]');
        if (currentPagination && nextPagination) currentPagination.replaceWith(nextPagination);

        const currentLoadMore = this.querySelector('[data-blog-load-more-container]');
        const nextLoadMore = nextWrapper.querySelector('[data-blog-load-more-container]');

        if (currentLoadMore && nextLoadMore) {
          currentLoadMore.replaceWith(nextLoadMore);
        } else if (currentLoadMore && !nextLoadMore) {
          currentLoadMore.remove();
        } else if (!currentLoadMore && nextLoadMore) {
          this.querySelector('[data-blog-pagination]')?.before(nextLoadMore);
        }
      } catch (error) {
        console.error('Blog load more error:', error);
      } finally {
        this.querySelector('[data-blog-list]')?.classList.remove('animation');
        this.querySelector('[data-blog-pagination]')?.classList.remove('animation');
        this.querySelector('[data-blog-load-more-container]')?.classList.remove('animation');
      }
    }

    bindTagDropdown() {
      const tagListButton = this.querySelector('[data-blog-tag-toggle]');
      const tagList = this.querySelector('[data-blog-tag-list]');
      if (!tagListButton || !tagList || tagListButton.dataset.bound === 'true') return;

      let open = false;
      tagListButton.addEventListener('click', () => {
        open = !open;
        tagList.style.maxHeight = open ? `${tagList.scrollHeight}px` : '0px';
        tagListButton.classList.toggle('is-open', open);
      });
      tagListButton.dataset.bound = 'true';
    }
  }

  customElements.define('blog-posts', BlogPosts);
}
